// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].use[1]!../../../../node_modules/postcss-loader/dist/cjs.js!../shared.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#quiz-box {
  background-color: var(--white);
  box-shadow: var(--shadow);
  display: flex;
  justify-content: space-between;
  margin-bottom: 1rem;
  color: var(--black);
  -webkit-text-decoration: none;
  text-decoration: none;

}

#quiz-box .quiz-result-absolute {
    margin-bottom: 0.5rem;
  }

#quiz-box #quiz-results {
    padding: 1rem;
    width: 15%;
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;
  }

#quiz-details {
  padding: 1rem;
  font-size: 1.25rem;
  width: 85%;
  line-height: 1.5rem;
}

#quiz-details-header {
  font-size: 1.25rem;
}

#quiz-details-header  > .default {
    font-style: italic;
    color: var(--grey2);
    margin-left: 1rem;
  }


#quiz-details-footer {
  font-size: 1rem;
  padding-top: 1rem;
  color: var(--grey3);
  display: inline-flex;
  flex-wrap: wrap;
}


#quiz-details-footer  > .quiz-setting {
    display: inline-flex;
    padding-right: 1.5rem;
  }


#quiz-details-footer > .quiz-setting  > .title {
      padding-left: 0.5rem;
    }


#quiz-details-footer > .quiz-setting  > .title::after {
      content: ":";
    }


#quiz-details-footer > .quiz-setting  > .value {
      padding-left: 0.5rem;
    }

#quiz-results.empty {
    background-color: var(--grey2);
    color: var(--grey3);
  }

#quiz-results.bad {
    background-color: var(--red3);
  }

#quiz-results.ok {
    background-color: var(--orange3);
  }

#quiz-results.good {
    background-color: var(--green2);
  }



@media (max-width: 48rem) {
    #quiz-details-footer > .quiz-setting  > .title {
      display: none;
    }
}
`, "",{"version":3,"sources":["webpack://./core/components/quizzes/Quiz.css"],"names":[],"mappings":"AAEA;EACE,8BAA8B;EAC9B,yBAAyB;EACzB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,6BAAqB;EAArB,qBAAqB;;AAevB;;AAbE;IACE,qBAAqB;EACvB;;AAEA;IACE,aAAa;IACb,UAAU;IACV,aAAa;IACb,mBAAmB;IACnB,sBAAsB;IACtB,uBAAuB;EACzB;;AAIF;EACE,aAAa;EACb,kBAAkB;EAClB,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AAOpB;;AALE;IACE,kBAAkB;IAClB,mBAAmB;IACnB,iBAAiB;EACnB;;;AAIF;EACE,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,oBAAoB;EACpB,eAAe;AAkBjB;;;AAhBE;IACE,oBAAoB;IACpB,qBAAqB;EAavB;;;AAXE;MACE,oBAAoB;IACtB;;;AAEA;MACE,YAAY;IACd;;;AAEA;MACE,oBAAoB;IACtB;;AAMF;IACE,8BAA8B;IAC9B,mBAAmB;EACrB;;AAEA;IACE,6BAA6B;EAC/B;;AAEA;IACE,gCAAgC;EAClC;;AAEA;IACE,+BAA+B;EACjC;;;;AAKF;IAEI;MACE,aAAa;IACf;AAEJ","sourcesContent":["@import \"../shared.css\";\r\n\r\n#quiz-box {\r\n  background-color: var(--white);\r\n  box-shadow: var(--shadow);\r\n  display: flex;\r\n  justify-content: space-between;\r\n  margin-bottom: 1rem;\r\n  color: var(--black);\r\n  text-decoration: none;\r\n\r\n  & .quiz-result-absolute {\r\n    margin-bottom: 0.5rem;\r\n  }\r\n\r\n  & #quiz-results {\r\n    padding: 1rem;\r\n    width: 15%;\r\n    display: flex;\r\n    align-items: center;\r\n    flex-direction: column;\r\n    justify-content: center;\r\n  }\r\n\r\n}\r\n\r\n#quiz-details {\r\n  padding: 1rem;\r\n  font-size: 1.25rem;\r\n  width: 85%;\r\n  line-height: 1.5rem;\r\n}\r\n\r\n#quiz-details-header {\r\n  font-size: 1.25rem;\r\n\r\n  > .default {\r\n    font-style: italic;\r\n    color: var(--grey2);\r\n    margin-left: 1rem;\r\n  }\r\n}\r\n\r\n\r\n#quiz-details-footer {\r\n  font-size: 1rem;\r\n  padding-top: 1rem;\r\n  color: var(--grey3);\r\n  display: inline-flex;\r\n  flex-wrap: wrap;\r\n\r\n  > .quiz-setting {\r\n    display: inline-flex;\r\n    padding-right: 1.5rem;\r\n\r\n    > .title {\r\n      padding-left: 0.5rem;\r\n    }\r\n\r\n    > .title::after {\r\n      content: \":\";\r\n    }\r\n\r\n    > .value {\r\n      padding-left: 0.5rem;\r\n    }\r\n  }\r\n}\r\n\r\n#quiz-results {\r\n\r\n  &.empty {\r\n    background-color: var(--grey2);\r\n    color: var(--grey3);\r\n  }\r\n\r\n  &.bad {\r\n    background-color: var(--red3);\r\n  }\r\n\r\n  &.ok {\r\n    background-color: var(--orange3);\r\n  }\r\n\r\n  &.good {\r\n    background-color: var(--green2);\r\n  }\r\n}\r\n\r\n\r\n\r\n@media (max-width: 48rem) {\r\n  #quiz-details-footer > .quiz-setting {\r\n    > .title {\r\n      display: none;\r\n    }\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
